export default __webpack_public_path__ + "static/media/css-sprites.204886b0.png";